import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store/store";
import Drawer from "@mui/material/Drawer";
import ScheduleAppointmentTotal from "./ScheduleAppointmentTotal";
import ScheduleAppointmentServices from "./ScheduleAppointmentServices";
import ScheduleAppointmentFormula from "./ScheduleAppointmentFormula";
import ScheduleAppointmentPatientInfo from "./ScheduleAppointmentPatientInfo";
import ScheduleAppointmentTitle from "./ScheduleAppointmentTitle";
import convertTitleInDrawer from "@/utils/converteTitleInDrawer";
import Title from "@/shared/components/Title/Title";
import { useNavigate } from "react-router";

import { resetExistAppointmentData } from "@/store/appointments/appointmentsSlice";

import { ISearchDrawerProps } from "@/shared/interfaces/ui";

import "./ScheduleAppointmentInfo.scss";
import CloseCross from "@/shared/components/CloseCross/CloseCross";

export default function ScheduleAppointmentInfo({
    toggleDrawer,
    open,
}: ISearchDrawerProps) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const appointmentData = useSelector(
        (state: RootState) => state.appointments,
    );
    const isLocalLoading = useSelector(
        (state: RootState) => state.ui.isLocalLoading,
    );
    const { date, notes, isAppointmentComplete } =
        appointmentData.existtAppointment;

    return (
        <Drawer
            open={open}
            onClose={() => {
                if (!isLocalLoading) {
                    toggleDrawer(false);
                    dispatch(resetExistAppointmentData());
                }
            }}
            anchor='right'
            slotProps={{
                paper: {
                    sx: {
                        overflowX: "hidden",
                    },
                },
            }}
        >
            <div
                className='drawer_container'
                id={"edit_patient_appointment_container"}
            >
                <div className='drawer_title_container shedule_title'>
                    <div className='shedule_title-contaniner'>
                        <Title
                            tag='h2'
                            text={`Пацієнт: ${appointmentData?.existtAppointment?.patientId?.name}`}
                            style={{ textAlign: "left", cursor: "pointer" }}
                            onClick={() => {
                                navigate(
                                    `/patients/${appointmentData?.existtAppointment?.patientId._id}`,
                                );
                            }}
                        />
                        <CloseCross
                            onClick={() => {
                                if (!isLocalLoading) {
                                    toggleDrawer(false);
                                }
                            }}
                        />
                    </div>
                </div>

                <ScheduleAppointmentTitle toggleDrawer={toggleDrawer} />
                <ScheduleAppointmentPatientInfo />
                <ScheduleAppointmentFormula
                    toggleDrawer={toggleDrawer}
                    isAppointmentComplete={isAppointmentComplete}
                />
                <div className='edit_drawer_container_notes drawer_item'>
                    <Title tag='h4' text={"Примітки"} />
                    <p className='about_subtitle about_notes'>{notes}</p>
                </div>
                <ScheduleAppointmentServices />
            </div>
            <ScheduleAppointmentTotal toggleDrawer={toggleDrawer} />
        </Drawer>
    );
}
